import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox
} from "@material-ui/core";
import { MaterialIcon } from "@loanbossinc/component-library";
import styled from "styled-components/macro";

const StyledTable = styled(Table)`&& {
  border: 1px solid #DADCE0;
  font-family: Work Sans;
  font-weight: 300;
}`;

const StyledTableHead = styled(TableHead)`&& {
  background-color: #FAFAFA;
  color: #5F6368;
  font-size: 16px;
}`;

const StyledHeadTableRow = styled(TableRow)`&& {
  && > th:first-child {
    padding-left: 52px;
  }
}`;

const StyledTableBody = styled(TableBody)`&& {
  font-size: 14px;
  font-weight: 300;
}`;

const StyledBodyTableRow = styled(TableRow)`&& {
  background-color: #FFFFFF;
  && > td:nth-child(4)::first-letter {
    text-transform: lowercase;
  }
  && > td:first-child {
    width: 0.5%;
    text-align-last: center;
  }
}`;

const StyledBodyTableCell = styled(TableCell)`&& {
  font-size: 14px;
  font-weight: 300;
  color: #000000;
}`;

const MuiSpanClone = styled.span`
  color: inherit;
  border: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  outline: none;
  padding: 0;
  position: relative;
  align-items: center;
  user-select: none;
  border-radius: 0;
  vertical-align: middle;
  justify-content: center;
  -moz-appearance: none;
  text-decoration: none;
  background-color: transparent;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  cursor: default;
  transition: none;
  flex: 0 0 auto;
  width: 48px;
  color: rgba(0, 0, 0, 0.54);
  height: 48px;
  font-size: 1.5rem;
  text-align: center;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 50%;
  && > span {
    width: 100%;
    display: flex;
    align-items: inherit;
    justify-content: inherit;
  }
`;

const ContactsTable = ({ viewableContacts = [], setContactsDataToSave }) => {
  const [viewableContactsState, setViewableContactsState] = useState(viewableContacts);

  const handleCheckMarkClick = id => {
    const newContactsData = viewableContacts.map(contact => (contact?.id === id ?
      ({
        ...contact,
        included: !contact?.included
      }) :
      ({ ...contact })));

    setContactsDataToSave(newContactsData);
  };

  useEffect(() => {
    const sortedViewableContacts = [...viewableContacts].sort((a, b) => {
      if (a.company?.name?.toLowerCase() === b.company?.name?.toLowerCase()) {
        if (a?.lastName?.toLowerCase() === b?.lastName?.toLowerCase()) {
          return 0;
        }

        return a?.lastName?.toLowerCase() > b?.lastName?.toLowerCase() ? 1 : -1;
      }

      return a.company?.name?.toLowerCase() > b.company?.name?.toLowerCase() ? 1 : -1;
    });

    setViewableContactsState(sortedViewableContacts);
  }, [viewableContacts]);

  return (
    <StyledTable>
      <StyledTableHead>
        <StyledHeadTableRow>
          <TableCell>Exclude?</TableCell>
          <TableCell>Company</TableCell>
          <TableCell>Contact</TableCell>
          <TableCell>Email</TableCell>
        </StyledHeadTableRow>
      </StyledTableHead>
      <StyledTableBody>
        {
          viewableContactsState.map(contact => (
            <StyledBodyTableRow key={contact?.id}>
              <StyledBodyTableCell padding="checkbox">
                {
                  contact?.unsubscribed ?
                    <MuiSpanClone>
                      <MaterialIcon iconName="block" style={{ color: "#C40A0A" }} />
                    </MuiSpanClone> :
                    <Checkbox
                      checked={!contact?.included ?? true}
                      onChange={() => handleCheckMarkClick(contact?.id)}
                    />
                }
              </StyledBodyTableCell>
              <StyledBodyTableCell>{contact?.company?.name}</StyledBodyTableCell>
              <StyledBodyTableCell style={{ textTransform: "capitalize" }}>{contact?.contactName}</StyledBodyTableCell>
              <StyledBodyTableCell>{contact?.email}</StyledBodyTableCell>
            </StyledBodyTableRow>
          ))
        }
      </StyledTableBody>
    </StyledTable>
  );
};

export default ContactsTable;
